export default "__VITE_ASSET__DGBxKCPD__"